module.exports = __webpack_public_path__ + "static/media/B4.c6c7321c.jpg";